import { defineMessages } from 'react-intl';

export default defineMessages({
    baDriver: {
        id: 'endorsement.ba.directives.templates.ba-edit-driver.Driver',
        defaultMessage: 'Driver',
    },
    baDrivers: {
        id: 'endorsement.ba.directives.templates.ba-edit-driver.Drivers',
        defaultMessage: 'Drivers',
    },
    baNewDriver: {
        id: 'endorsement.ba.directives.templates.ba-edit-driver.New Driver',
        defaultMessage: 'New Driver',
    },
    licenceMatchMsg: {
        id: 'quoteandbind.ba.controllers.BADriverDetailsCtrl.LicenceMatchMsg',
        defaultMessage: 'Sorry, but this drivers license number matches that of {driver}. Please ensure that all licence numbers are unique.',
    },
    licenseNotUnique: {
        id: 'quoteandbind.ba.controllers.BADriverDetailsCtrl.Licence number is not unique',
        defaultMessage: 'Licence number is not unique'
    },
    addAnotherDriver: {
        id: 'endorsement.ba.views.ba-driver-details.Add Another Driver?',
        defaultMessage: 'Add Another Driver?'
    },
    addDriver: {
        id: 'endorsement.ba.views.ba-driver-details.Add Driver',
        defaultMessage: 'Add Driver'
    },
    removeDriverTitle:{
        id: 'endorsement.ba.views.ba-driver-details.Remove Driver?',
        defaultMessage: 'Remove Driver?'
    },
    removeDriverDescription:{
        id: 'endorsement.ba.views.ba-driver-details.Are you sure you want to remove this driver from the list of drivers?',
        defaultMessage: 'Are you sure you want to remove this driver from the list of drivers?'
    }
});
